import { atom } from 'jotai';

export const isCompanyProfileEditAtom = atom(false);
